/**
 * @deprecated Bridge — delegates to LoadingCoordinator. Prefer requestLoading/releaseLoading directly.
 */

import {
  getCoordinatorVisibleState,
  markBootHandoffComplete,
  getBootHandoffRemainingMs,
  requestLoading,
  releaseLoading,
} from '@/lib/loading/loadingCoordinatorStore';
import type { LoadingSource } from '@/lib/loading/types';

export interface AppLoaderState {
  bootstrapping: boolean;
  reason?: string;
}

const reasonToSource = (reason: string): LoadingSource => {
  if (reason === 'bootstrap_root') return 'boot';
  if (reason === 'admin_gate') return 'admin-gate';
  return 'boot';
};

const activeReasons = new Map<string, boolean>();

let cachedBootstrap: AppLoaderState = { bootstrapping: false };

export function getBootstrappingState(): AppLoaderState {
  const bootstrapping = [...activeReasons.values()].some(Boolean);
  const reason = [...activeReasons.entries()].find(([, v]) => v)?.[0];
  if (cachedBootstrap.bootstrapping === bootstrapping && cachedBootstrap.reason === reason) {
    return cachedBootstrap;
  }
  cachedBootstrap = { bootstrapping, reason };
  return cachedBootstrap;
}

export function setBootstrapping(value: boolean, reason?: string): void {
  const key = reason ?? 'unknown';
  if (activeReasons.get(key) === value) return;
  activeReasons.set(key, value);
  const id = `bootstrap:${key}`;
  if (value) {
    requestLoading({ id, source: reasonToSource(key) });
  } else {
    releaseLoading(id);
  }
}

export function subscribe(listener: () => void): () => void {
  return () => {};
}

export function markBootstrapSplashHandoffComplete(): void {
  markBootHandoffComplete();
}

export { getBootHandoffRemainingMs as getBootstrapHandoffRemainingMs };

export function isBootstrapOverlayHandoffActive(): boolean {
  return getBootHandoffRemainingMs() > 0;
}

export function getActiveBootstrapReasons(): string[] {
  return [...activeReasons.entries()].filter(([, v]) => v).map(([k]) => k);
}

/** Coordinator-aware bootstrapping for layout gates. */
export function isGlobalBootstrapActive(): boolean {
  const state = getCoordinatorVisibleState();
  return state.surface === 'fullscreen' || getBootstrappingState().bootstrapping;
}
